// The localStorage keys an impersonation writes. They are display caches: the
// access token says whether the browser is impersonating (see
// impersonationUtils.isImpersonating). No app imports, so auth-session can use
// this without a cycle.

export const IMPERSONATION_SESSION_KEY = 'impersonationSession';
export const IMPERSONATED_USER_INFO_KEY = 'impersonatedUserInfo';
export const ORIGINAL_TOKENS_KEY = 'originalTokens';
export const ORIGINAL_AUTH_DATA_KEY = 'originalAuthData';

export const IMPERSONATION_CHANGED_EVENT = 'impersonationChanged';

const IMPERSONATION_KEYS = [
  IMPERSONATION_SESSION_KEY,
  IMPERSONATED_USER_INFO_KEY,
  ORIGINAL_TOKENS_KEY,
  ORIGINAL_AUTH_DATA_KEY,
];

export const hasImpersonationState = (): boolean =>
  typeof localStorage !== 'undefined' && IMPERSONATION_KEYS.some((key) => localStorage.getItem(key) !== null);

/**
 * Removes every impersonation key. Called on every session start and end, so
 * a forced logout during impersonation cannot leave the banner behind for the
 * next login. Notifies listeners only when something was actually removed.
 */
export const clearImpersonationState = () => {
  if (!hasImpersonationState()) return;
  for (const key of IMPERSONATION_KEYS) localStorage.removeItem(key);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(IMPERSONATION_CHANGED_EVENT));
  }
};
